<template>
  <div>
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ $t('archive.updating') }}
          <v-progress-linear class="mb-0" color="white" indeterminate></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" persistent width="700">
      <v-btn slot="activator" block color="primary">
        {{ $t('archive.edit') }}
      </v-btn>
      <v-card>
        <v-card-title class="headline" primary-title>
          {{ $t('archive.edit') }}
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="archive.customName" :label="`${$t('archive.file-name')}`" required
                        width="80%"></v-text-field>
          <v-text-field v-model="archive.archType" :label="`${$t('archive.arch_type')}`" required
                        width="80%"></v-text-field>
          <v-textarea v-model="archive.text" :label="`${$t('archive.text')}`" clear-icon="cancel" required></v-textarea>
          <v-textarea v-model="archive.note" :label="`${$t('archive.note')}`" clear-icon="cancel" required></v-textarea>
        </v-card-text>


        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-progress-circular v-if="loading" color="primary" indeterminate spacing="pr-4"></v-progress-circular>
          <v-btn color="blue darken-1" flat @click="cancel">{{ $t('cyclic.abort') }}</v-btn>
          <v-btn :disabled="loading" color="primary" @click="upload">
            {{ $t('archive.filter.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import http from '@/plugins/http'
import DataTimeHelper from '@/plugins/DataTimeHelper'

export default {
  props: ["archive", "archiveOrgin"],
  data() {
    return {
      dialog: false,
      fileName: '',
      url: '',
      fileObject: null,
      cardResult: '',
      name: '',
      note: '',
      archType: '',
      lastModifiedDate: '',
      loading: false,
      valid: false,
    }
  },
  methods: {
    clearForm() {
      this.note = ""
      this.fileName = ""
      this.name = ""
      this.fileObject = null
      this.type = null
      this.loading = false;
    },
    upload() {
      if (this.archive.customName.length > 3) {
        this.loading = true
        http.put('archive/' + this.archive.id, this.archive).then(() => {
          this.archiveOrgin.note = this.archive.note
          this.archiveOrgin.archType = this.archive.archType
          this.archiveOrgin.customName = this.archive.customName
          this.archiveOrgin.text = this.archive.text
          this.archive.modifyTime = DataTimeHelper.getDateTime()
          this.archiveOrgin.modifyTime = DataTimeHelper.getDateTime()
          this.dialog = false
        }).catch(() => {
        }).finally(() => this.loading = false)
      }
    },
    cancel() {
      this.archive.note = this.archiveOrgin.note
      this.archive.archType = this.archiveOrgin.archType
      this.archive.customName = this.archiveOrgin.customName
      this.archive.text = this.archiveOrgin.text
      this.loading = false
      this.dialog = false
    }
  }
}
</script>

<style scoped>
</style>
